// FE-SCRM-056 — REST client for the sales-playbook surface.
//
// Three endpoints (all under ``/api/v1/sales``):
//
//   GET  /playbooks                          — list active playbooks
//   GET  /playbooks/{id}                     — detail incl. blocks
//   POST /opportunities/{id}/apply-playbook  — apply (idempotent)
//
// Idempotency: a second apply for the same (opportunity, playbook)
// returns 200 with the existing application. The mutation hook
// surfaces this to callers via the response payload alone — we don't
// distinguish 200 vs 201 at the FE because the body shape is the
// same.

import { api } from "@/api/client";

import type {
  ApplyPlaybookResponse,
  PlaybookDetail,
  PlaybookListResponse,
} from "./types";


export function fetchPlaybooks(
  opts?: { signal?: AbortSignal },
): Promise<PlaybookListResponse> {
  return api.get<PlaybookListResponse>(
    "/api/v1/sales/playbooks", opts,
  );
}


export function fetchPlaybookDetail(
  playbookId: string,
  opts?: { signal?: AbortSignal },
): Promise<PlaybookDetail> {
  return api.get<PlaybookDetail>(
    `/api/v1/sales/playbooks/${playbookId}`, opts,
  );
}


export function applyPlaybook(
  opportunityId: string,
  playbookId: string,
): Promise<ApplyPlaybookResponse> {
  return api.post<ApplyPlaybookResponse>(
    `/api/v1/sales/opportunities/${opportunityId}/apply-playbook`,
    { playbook_id: playbookId },
  );
}
